export default __webpack_public_path__ + "static/media/alert-icon.4fa564ad.svg";